// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2eC1-","select":"styles_select__2-0S8"};